module.exports = __webpack_public_path__ + "static/media/c1.ff01116a.jpg";